const ClipboardJS = require("clipboard");

$(document).ready(function () {
  const clipboard = new ClipboardJS(".btn-promo-code");
  clipboard.on("success", function () {
    Swal.fire({
      position: "bottom-start",
      icon: "success",
      title: "Promo code copied to clipboard!",
      toast: true,
      timer: 1500,
      showConfirmButton: false,
    });
  });

  $("#promo-container").on("click", ".btn-promo-chat", function (e) {
    e.preventDefault();
    if (typeof Intercom == "function") {
      const code = $(this).data("code");
      Intercom("showNewMessage", code);
    }
  });
});
